<template>
  <div>

    <a href="" @click.prevent="modalTriggerConfirmClone=true">Delete</a>

    <modal v-if="modalTriggerConfirmClone" @close="modalTriggerConfirmClone = false">
      <h3 slot="header">Delete Category</h3>
      <div class="content" slot="body">
        <div>Are you sure you want to delete this category {{ category_name }}? </div>
      </div>
      <div class="form-group-submit clearfix" slot="footer">
        <button class="btn btn-cancel btn-transparent pull-left" @click.prevent="modalTriggerConfirmClone = false">Cancel</button>
        <a class="pull-right btn btn-primary" :href="'/category/' + category_clone_id + '/delete'">Yes, delete category</a>
      </div>
    </modal>

  </div>

</template>

<script>
import modal from './Modal.vue';

export default {
  components: { modal },
  props: ['category_clone_id', 'category_name'],
  data() {
    return {
      modalTriggerConfirmClone: false,
    }
  }
}
</script>